<style scoped>
.btnsignup {
  width: 100%;
  border: none;
  background-color: transparent;
}
.no-error-visible {
  display: none;
}

.btn.facebook {
  background-color: #3b5998;
}

.btn.facebook i {
  font-size: 1.5em;
}

.btn-full {
  width: 100%;
}

.divider {
  margin-top: 12px;
  margin-bottom: 12px;
}

.login-divider {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #f9f9f9;
  padding-left: 12px;
  padding-right: 12px;
}
#login-divider-container {
  position: relative;
  padding-top: 12px;
  padding-bottom: 12px;
}
.div-virtical {
  border-right: 1px solid lightgray;
}
.mrgnTop {
  margin-top: 80px;
}
.margintop {
  margin-top: 80px;
}
.pdding {
  margin-top: 30px;
}
.pdd-left {
  padding-left: 30px;
}

.btn {
  color: #ffffff;
}
</style>

<template lang="pug">
div
  v-row
    v-col(cols='12', sm='12')
      v-row.mt-16.pdd-left
        v-col(cols='12', sm='12')
          h6.center Get your favorite drinks here! Shop with us
            button.btnsignup.pdding
              router-link.btn.waves-effect.btn-full(
                :to='"/register-shopper"',
                v-tooltip.bottom='{content: msgshopper, class: "custom-tooltip"}'
              ) Register as a shopper
        v-col.margintop(cols='12', sm='12')
        v-col#login-divider-container(cols='12', sm='12')
        v-col(cols='12', sm='12')
          h6.center Want exclusive products to sell in your shop?
            button.btnsignup.pdding
              router-link.btn.waves-effect.btn-full(
                :to='"/register-reseller"',
                v-tooltip.bottom='{content: msgreseller, class: "custom-tooltip"}'
              ) Register as a reseller
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  data() {
    return {
      msgshopper:
        'If you personally love wine and spirits as much as you love yourself and you’re not selling it to anyone, register here.',
      msgreseller:
        'If you are in the business of spirits and want to sell exclusive items, register here.',
    }
  },
  mounted() {
    const maxDate = new Date(Date.now() - 567648000000) // 18 years old;
    this.$M.Datepicker.init(this.$refs.datepicker, {
      yearRange: [maxDate.getFullYear() - 100, maxDate.getFullYear()],
      maxDate: maxDate,
      defaultDate: maxDate,
      onSelect: this.birthdaySelected,
      format: 'mmm dd, yyyy',
    })
  },
  methods: {
    birthdaySelected(birthday) {
      this.customer.birthday = birthday
    },
    register() {
      if (!this.customer.above18) {
        this.$snackbar.show({
          text: 'You must confirm that you are 18 years old or above to register.',
        })
      } else {
        this.$http
          .post(`${this.$config.API_URL}/account/register`, this.customer)
          .then((data) => {
            return this.$store.dispatch('auth/localLogin', {
              email: this.customer.username,
              password: this.customer.password,
              scope: 'customer',
            })
          })
          .then((user) => {
            if (user.type !== 'customer') {
              this.$store.dispatch('auth/clear')
              throw new Error('Invalid account')
            }

            this.$snackbar.show({ text: 'Account Created Successfully.' })

            this.$router.replace('/')
          })
          .catch((err) => {
            if (err.response && err.response.status === 400) {
              this.$snackbar.show({
                text:
                  'Registration failed: ' +
                  err.response.data.errors[0].messages[0],
              })
            } else {
              this.$snackbar.show({
                text: 'Oops, there seems to be a problem: ' + err.message,
              })
            }
          })
      }
    },
    prev() {
      this.step--
    },
    next() {
      this.step++
    },
    submit() {},
  },
  components: {
    FormWizard,
    TabContent,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-customer-register.vue